import { I18nextProvider } from 'react-i18next';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Toaster } from 'sonner';

import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { RoleRoute } from './components/auth/RoleRoute';
import ErrorBoundary from './components/layout/ErrorBoundary';
import { HRLayout } from './components/layout/HRLayout';
import i18n from './lib/i18n';
import { DashboardPage } from './pages/DashboardPage';
import { DocumentPoliciesPage } from './pages/DocumentPoliciesPage';
import { DocumentsPage } from './pages/DocumentsPage';
import { JobPostingCreatePage } from './pages/JobPostingCreatePage';
import { JobPostingEditPage } from './pages/JobPostingEditPage';
import { JobPostingsPage } from './pages/JobPostingsPage';
import { LoginPage } from './pages/LoginPage';
import { NotificationTemplatesPage } from './pages/NotificationTemplatesPage';
import { PromptSetsPage } from './pages/PromptSetsPage';
import { ReportsPage } from './pages/ReportsPage';
import { SchedulingPage } from './pages/SchedulingPage';
import { SettingsPage } from './pages/SettingsPage';
import { SubmissionDetailPage } from './pages/SubmissionDetailPage';

function App() {
  return (
    <ErrorBoundary
      title={i18n.t('errors.boundary.title')}
      description={i18n.t('errors.boundary.description')}
      reloadLabel={i18n.t('errors.boundary.reload')}
      showErrorDetails={import.meta.env.DEV}>
      <I18nextProvider i18n={i18n}>
        <Toaster position='top-right' richColors />
        <BrowserRouter>
          <Routes>
            <Route path='/login' element={<LoginPage />} />
            <Route
              element={
                <ProtectedRoute>
                  <HRLayout />
                </ProtectedRoute>
              }>
              <Route path='/job-postings' element={<JobPostingsPage />} />
              <Route path='/job-postings/create' element={<JobPostingCreatePage />} />
              <Route path='/job-postings/:id' element={<JobPostingEditPage />} />
              <Route path='/dashboard' element={<DashboardPage />} />
              <Route path='/submissions/:id' element={<SubmissionDetailPage />} />
              <Route path='/documents' element={<DocumentsPage />} />
              <Route
                path='/document-policies'
                element={
                  <RoleRoute allowedRoles={['admin']}>
                    <DocumentPoliciesPage />
                  </RoleRoute>
                }
              />
              <Route
                path='/prompt-sets'
                element={
                  <RoleRoute allowedRoles={['admin']}>
                    <PromptSetsPage />
                  </RoleRoute>
                }
              />
              <Route path='/scheduling' element={<SchedulingPage />} />
              <Route
                path='/notification-templates'
                element={
                  <RoleRoute allowedRoles={['admin']}>
                    <NotificationTemplatesPage />
                  </RoleRoute>
                }
              />
              <Route path='/reports' element={<ReportsPage />} />
              <Route
                path='/settings'
                element={
                  <RoleRoute allowedRoles={['admin']}>
                    <SettingsPage />
                  </RoleRoute>
                }
              />
            </Route>
            <Route path='*' element={<Navigate to='/login' replace />} />
          </Routes>
        </BrowserRouter>
      </I18nextProvider>
    </ErrorBoundary>
  );
}

export default App;
